import React from 'react';
import { BsToggleOnIcon, ToggleOffIcon } from '../../../../../Components/Icons/Icons';
import AutomationRuleFilters from './AutomationRuleFilters';
import RecurrenceScheduleComponent from './RecurrenceScheduleComponent';
import { getColorSettings } from '../../../../../Utils/helper/commonUtils';
import { Alert, Box, IconButton, Stack, Typography } from '@mui/material';
import { AppColors } from '../../../../../Utils/helper/AppColors';


const AdvancedOptions = ({ openOptions, setOpenOptions , details, setDetails , setIsDialogOpenCheckData }) => {
        const localSettingColors = getColorSettings();
                // console.log('detttt', details);
            // Function to toggle the visibility of advanced options
                const toggleAdvancedOptions = () => {
                   if(openOptions){
                          setOpenOptions(false);
                     setDetails((prevDetails) => {
                        const { advancedOptions , ...rest} = prevDetails;
                        return {
                        ...rest,
                        advancedOptionsEnabled: false,
                    }
                     });
                   }
                   else{
                        setOpenOptions(true);
                        setDetails((prevDetails) => ({
                            ...prevDetails,
                            advancedOptionsEnabled: true,
                        }));
                   }
                }
    
	return (
		<Box>
			{/* Advanced Options Heading */}
			<Stack direction="row" alignItems="center"  sx={{ width: '100%', gap: 2 }}>
				<Typography
					sx={{
						fontWeight: 600,
						fontStyle: 'SemiBold',
						fontSize: 20,
					}}
				>
					Advanced Options
				</Typography>

				<IconButton
					onClick={() => toggleAdvancedOptions()}
					size="small"
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						padding: 0,
					}}
				>
					{openOptions ? (
						<BsToggleOnIcon color={localSettingColors.fontColor} size={26} />
					) : (
						<ToggleOffIcon color={localSettingColors.fontColor} size={26} />
					)}
				</IconButton>
			</Stack>

			{/* Info message below heading */}
            <Alert severity="info" sx={{ mb: 1, fontSize: 14 , padding: 0 , background : 'none' , '& .MuiAlert-icon': { color: '#42a5f5' , marginRight: 1 } }}>
             Automatically enroll newly added employees into this campaign at specified intervals, based on configurable rule sets.
            </Alert>

            {/* Advanced Options Content */}
            {openOptions && (
                <>

                                    <RecurrenceScheduleComponent details={details} setDetails={setDetails} />
                                   <AutomationRuleFilters details={details} setDetails={setDetails} setIsDialogOpenCheckData={setIsDialogOpenCheckData} />

                </>
            )}
		</Box>
	);
};

export default AdvancedOptions;
